:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.range-wrapper {
  background-color: #ffffff;
}

@media screen and (min-width: 980px) {
  .range-wrapper {
    padding: 40px 0 49px;
  }
}

@media screen and (max-width: 979px) {
  .range-wrapper {
    padding: 20px 16px 48px;
  }
}

@media screen and (min-width: 980px) {
  .range-main {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }
}

.range-main-cta-button-block {
  display: block;
}

@media screen and (min-width: 980px) {
  .range-main-cta-button-block {
    display: none;
  }
}

@media screen and (min-width: 980px) {
  :host(.pesBusinessHeader) .range-main {
    width: auto;
    margin: 20px auto 40px;
  }
}

@media screen and (min-width: 980px) {
  :host(.pesBusinessHeader) .range-wrapper {
    padding-right: 8px;
    padding-left: 8px;
    margin-right: auto;
    margin-left: auto;
  }
}